import { render, staticRenderFns } from "./LsInfoCard.vue?vue&type=template&id=4ad3564e&scoped=true&"
import script from "./LsInfoCard.vue?vue&type=script&lang=js&"
export * from "./LsInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./LsInfoCard.vue?vue&type=style&index=0&id=4ad3564e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad3564e",
  null
  
)

export default component.exports